<template>
  <div 
    v-show="active"  
    id="image-modal" 
    :class="{'is-active': active}"
    class="ec-modal image-modal is-fullscreen"
    @click.self="closeModal">
    <div class="ec-modal-image animated fadeIn blue-border">
      <a 
        href="#" 
        class="close-icon modal-close" 
        @click.prevent="closeModal"/>
      <img :src="image">
    </div>
  </div>
</template>

<script>
import Modal from './Modal.mixin.vue'

export default {
mixins: [Modal],
    data: function() {return {
      active: false,
      loading: false,
      image: null,
    }},
    created() {
      this.$event.$on('show-image', (image) => {
        this.image = image
        this.active = true
        this.$store.modalOpen = true
      })
  },
}
</script>